import React from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import styled from "@emotion/styled";

const StyledCard = styled(Card)({
  backgroundColor: "#000",
  color: "#fff",
  padding: "20px",
  borderRadius: "20px",
});

const Intro = () => {
  return (
    <Container maxWidth="lg" sx={{ textAlign: "center", mt:{xs:16,md:4,lg:4},mb:4,}}>
      <Typography variant="h4" gutterBottom>
        WELCOME TO TRUE CHOICE CAR'S
      </Typography>
      <div className="border-11"></div>
      <div className="border-12"></div>
      <Grid container sx={{ position: "relative", mt: 4}}>
        <Grid item xs={12} md={12}>
          <StyledCard>
            <CardContent>
              <Typography variant="body1">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s.
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  fontWeight: "bold",
                  color: "#FFC107",
                  cursor: "pointer",
                }}
                onClick={() => (window.location.href = `/aboutus`)}
              >
                Read More
              </Typography>
            </CardContent>
          </StyledCard>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Intro;
